import { createContext, useContext } from 'react';
import noop from "lodash/noop";
import styles from "./DataTable.module.css";
export const TableContext = createContext({
  styles,
  columns: {
    configurable: true,
    config: [],
    setConfig: noop
  }
});
export const useTableContext = () => useContext(TableContext);